// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__a05c3","noInteraction":"EventWrapper_noInteraction__dVouG","pointerPassthrough":"EventWrapper_pointerPassthrough__3-dtS"};